import { render, staticRenderFns } from "./TextMessages.vue?vue&type=template&id=5e6d147e&scoped=true&"
import script from "./TextMessages.vue?vue&type=script&lang=js&"
export * from "./TextMessages.vue?vue&type=script&lang=js&"
import style0 from "./TextMessages.vue?vue&type=style&index=0&id=5e6d147e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d147e",
  null
  
)

export default component.exports